export const getISPLink = (pageType: string) => {
  return `${window.location.origin}/iseekplant/${pageType}`;
};
